<template>
  <div id="guided">
    <top></top>
    <div class="guided bg_wrap">
      <div class="container">
        <newTitle
          class="guided_title"
          :title="'Exhibition Guided Tour'"
        ></newTitle>
        <div class="guided_button" @click="toRegister">
          <span>Register Now</span
          ><img src="../../assets/imgs/icon_wright.png" alt="" />
        </div>
        <div v-for="(item, index) in list" :key="index" class="guided_list">
          <div class="guided_special_title">
            <titleConfig
              v-if="item.name_en"
              :title="item.name_en"
              :type="2"
              class="guided_title2"
            ></titleConfig>
            <img
              v-if="item.imgs && item.imgs.length > 0"
              :src="item.imgs[0]"
              alt=""
            />
          </div>
          <div class="guided_content" v-html="item.content_en"></div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import newTitle from "@/components/new_title.vue";
import titleConfig from "@/components/title.vue";
import { webAbout } from "@/api/api";
export default {
  components: {
    top,
    bottom,
    newTitle,
    titleConfig,
  },
  data() {
    return {
      type: "",
      lang: "",
      list: "",
    };
  },
  created() {
    this.lang = this.$language;
    this.type = this.$route.query.type;
    this.getRichtext();
  },
  methods: {
    toRegister() {
      window.open("https://alz3dfoi.jsjform.com/f/gafiBF", "__blank");
    },
    async getRichtext() {
      const res = await webAbout({
        type: this.type,
      });
      if (res.code == 1) {
        this.list = res.data.lists;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.guided_button {
  width: 228px;
  height: 50px;
  background-color: #cf121b;
  border-radius: 40px;
  color: #fff;
  margin: 50px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  img {
    margin-left: 10px;
    width: 16px;
    height: 16px;
  }
}
.guided_special_title {
  position: relative;
  z-index: 9;
  margin-bottom: 40px;
  img {
    width: 234px;
    height: 184px;
    display: block;
    position: absolute;
    right: 40px;
    bottom: 0px;
    z-index: 1;
  }
}
// .guided_list {
//   .guided_title2 {
//     margin-bottom: 30px;
//   }
// }
.guided_content {
  margin-bottom: 80px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: keep-all;
  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 1280px) {
  .guided_button {
    margin: 20px auto;
    width: 160px;
    height: 35px;
    font-size: 14px;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .guided_content {
    margin-bottom: 30px;
  }
}

@media only screen and (max-width: 767px) {
  .guided_button {
    margin: 20px auto;
    width: 160px;
    height: 35px;
    font-size: 14px;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .guided_content {
    margin-bottom: 30px;
  }
}
</style>